import React, { useState, useEffect, useRef, useCallback } from 'react';
import { toast } from "react-hot-toast";
import { motion } from "framer-motion";
import { abrirBaseDeDatosLocal, deportistaEliminadoPWS, deportistaRegistradoPWS, eliminarFoto, eliminarMensaje, eliminarNadador, eliminarTokenNotificacion, notificacion, organizarPorTiempos, registrarClubAlTorneo, registrarDeportistaGeneral, registrarDirectivosClub, registrarDirectivosPws, registrarMensaje, registrarNadador, registrarRelevo, resizeImage, sacarEdadDeLaCategoria, subirFoto, traerDeportistaRanking, traerDeportistas, traerDirectivos, traerMensajes, traerPruebasParaRegistroJPC, traerRelevosEquipo, traerTokensNotificacionInscripciones, verificarLimpiar}  from "../controllers/configuracionFirebase";
import { Tooltip as Mensaje } from "react-tooltip";
import { acomodarTextoCategoria } from '../controllers/estilos';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import Swal from 'sweetalert2';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { reporteInscritos } from '../controllers/pdfs';
import { saveAs } from 'file-saver';
import { datosAdmin } from '../controllers/administrador';
import Conctatenos from './Conctatenos';
import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { OverlayPanel } from 'primereact/overlaypanel';
import { extraerDatosPdf } from '../controllers/ai';
import { Tag } from 'primereact/tag';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import Cropper from 'react-easy-crop';
import { Checkbox } from 'primereact/checkbox';

const InscripcionNadadores = ({ 
  usuario,
  idTorneoParticipando, 
  torneoEspecifico,
  setListPruebas,
  listPruebas,
  pruebasCompletas, 
  listadoCategorias,
  fechaGoogle}) => {

  const [ listNombresRanking, setListNombresRanking ] = useState([]);
  const [ busquedaListNombresRanking, setBusquedaListNombresRanking ] = useState([]);
  const [ deportistaSelectRanking, setDeportistaSelectRanking ] = useState();
  const [ nadadores, setNadadores ] = useState([]);
  const [ nadadoresRelevo, setNadadoresRelevo ] = useState([]);
  const [ globalFilter, setGlobalFilter ] = useState(null);
  const [ expandedRows, setExpandedRows ] = useState(null);
  const [ dialogInscripcion, setDialogInscripcion ] = useState(false);
  const [ dialogFotosDeportistas, setDialogFotosDeportistas ] = useState(false);
  const [ dialogDirectivos, setDialogDirectivos ] = useState(false);
  const [ dialogRelevos, setDialogRelevos ] = useState(false);
  const [ dialogMensajes, setDialogMensajes ] = useState(false);
  const [ mensajes, setMensajes ] = useState([]);
  const [ mostrar, setMostrar ] = useState(false);
  const [ pruebasTiempos, setPruebasTiempos ] = useState([]);
  const [ pruebasId, setPruebasId ] = useState([]);
  const [ mostrarCategorias, setMostrarCategorias ] = useState([]);
  const [ sexo, setSexo ] = useState('');
  const [ edadRegistrada, setEdadRegistrada ] = useState();
  const [ mostrarJornadas, setMostrarJornadas ] = useState([]);
  const [ deportistas, setDeportistas ] = useState([]);
  const [ deportistaGeneral, setDeportistaGeneral ] = useState();
  const [ modificar, setModificar ] = useState(false);
  const [ pdfUrl, setPdfUrl ] = useState();
  const [ directivos, setDirectivos ] = useState([{id: 0, nombre: '', cel: '', rol: ''}]);
  const [ relevos, setRelevos ] = useState([]);
  const [ elegirRelevos, setElegirRelevos ] = useState(-1);
  const [ relevoElegido, setRelevoElegido ] = useState('');
  const [ esRelevoMaster, setEsRelevoMaster ] = useState(false);
  const [ listaDeportistasRelevo, setListaDeportistasRelevo ] = useState([]);
  const [ relevoEdadInicioFin, setRelevoEdadInicioFin ] = useState({
    edadI: 0,
    edadF: 0
  });
  const [ inputsDeportistasRelevos, setInputsDeportistasRelevos ] = useState([{
    name: '',
    code: '',
    doc: '',
    edad: 0
  }]);
  const [ nadadoresSinPruebas, setNadadoresSinPruebas ] = useState([]);
  const [ preview, setPreview ] = useState(null);
  const [ blobFoto, setBlobFoto ] = useState(null);
  const [ crop, setCrop ] = useState({ x: 0, y: 0 });
  const [ zoom, setZoom ] = useState(1);
  const [ areaPixels, setAreaPixels ] = useState(null);
  const [ cargandoRecorte, setCargandoRecorte ] = useState(false);
  const [ fotoRecortada, setFotoRecortada ] = useState(false);
  const [ fotoSinFondo, setFotoSinFondo ] = useState(false);
  const [ visibilidadRelevos, setVisibilidadRelevos ] = useState(false);
  const pdfEjemplo = useRef(null);
  const misDeportistasRef = useRef(null);

  function descargar(){
    saveAs(pdfUrl, `Reporte Inscripción ${usuario.nombreclub}.pdf`);
  }

  function calcularEdad(fecha) {
    if(torneoEspecifico.edCumplida === 'no'){
      let hoy = new Date();
      let fechaNacimiento = fecha;
      let cumple = fechaNacimiento.split('-');
      let cumpleanosDia = parseInt(cumple[2]);
      let cumpleanosMes = parseInt(cumple[1])
      let cumpleanosAno = parseInt(cumple[0]);
      let edad = hoy.getFullYear() - cumpleanosAno
      let m = (hoy.getMonth() + 1) - cumpleanosMes;
  
      if((cumpleanosMes) <= 12){
        edad--;
      }
  
      if(cumpleanosMes > 12){
        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanosDia)) {
          edad--;
        }
      }
  
      return edad;
    }
    if(torneoEspecifico.edCumplida === 'si'){
      let hoy = new Date();
      let fechaNacimiento = fecha;
      let cumple = fechaNacimiento.split('-');
      let cumpleanosAno = parseInt(cumple[0]);
      let edad = hoy.getFullYear() - cumpleanosAno;

      return edad;
    }
  }
  
  function sacarEdadyGenero(){
    const fecha = document.getElementById('fechaNacimiento').value;
    const auxSexo = document.getElementById('genero').value;
    setSexo(auxSexo);
    if(fecha !== ""){
      if(parseInt(edadRegistrada) !== calcularEdad(fecha)){
        setMostrar(false);
      }
      setEdadRegistrada(calcularEdad(fecha));
    }
  }

  function sacarCategoriaInscita(){
    let auxCategoria = new Set();
    listPruebas.forEach((lisPrue)=>{
      const relevo = lisPrue.prueba.match(/Relevo/g);
      if(!relevo){
        lisPrue.requisitos.forEach((req)=>{
          if(req.genero === 'Mixto'){
            if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada){
              auxCategoria.add(lisPrue.categoria);
            }
          }else{
            if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada && req.genero === sexo){
              auxCategoria.add(lisPrue.categoria);
            }
          }
        })
      }
    })
    return Array.from(auxCategoria);
  }

  function elegirPruebas(){
    setMostrar(true);
    if(!edadRegistrada || sexo === ''){
      toast.error('Por favor, llena primero los campos.');
    }else{
      const mostrarJornadas = [];
      const categorias = new Set();
      torneoEspecifico.jornadas.forEach((jor)=>{
        const auxPruebas = [];
        const auxJornada = {}
        jor.categoria.forEach((cate)=>{
          const sacarCategoria = sacarCategoriaInscita();
          if(sacarCategoria.includes(cate)){
            categorias.add(cate);
            jor.pruebas.forEach((prue)=>{
              const auxPrueba = listPruebas.filter((listPrue)=>{return listPrue.id === prue.idPrueba});
              if(auxPrueba.length !== 0){
                const auxP = new Set();
                const relevo = auxPrueba[0].prueba.match(/Relevo/g);
                if(!relevo){
                  auxPrueba[0].requisitos.forEach((req)=>{
                    if(req.genero === 'Mixto'){
                      if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada){
                        auxP.add(auxPrueba[0]);
                      }
                    }else{
                      if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada && req.genero === sexo){
                        auxP.add(auxPrueba[0]);
                      }
                    }
                  })
                }
                auxPruebas.push(...Array.from(auxP));
              }
            })
          }
        })

        const sacarPruebasRepetidas = new Set();
        const auxIdsPruebas = new Set();

        auxPruebas.forEach((prue)=>{
          if(!auxIdsPruebas.has(prue.id)){
            auxIdsPruebas.add(prue.id);
            sacarPruebasRepetidas.add(prue);
          }
        })

        if(Array.from(sacarPruebasRepetidas).length !== 0){
          auxJornada.jornada = jor.jornada;
          auxJornada.pruebas = Array.from(sacarPruebasRepetidas);
          mostrarJornadas.push(auxJornada);
        }
      })

      if(mostrarJornadas.length === 0){
        toast.error('La categoria que intenta registrar, no compite en este torneo.');
      }
      
      setMostrarJornadas(mostrarJornadas);
      setMostrarCategorias(Array.from(categorias));
    }
  }

  function nombreNadadorMayuscula(nombre){
    const nombreMinuscula = nombre.toLowerCase();
    const nombrecompleto = nombreMinuscula.split(' ');
    let nombreMayuscula = '';
    for (let i = 0; i < nombrecompleto.length; i++) {
      nombreMayuscula += nombrecompleto[i].charAt(0).toUpperCase() + nombrecompleto[i].slice(1) + " ";
    }
    return nombreMayuscula.trim();
  }

  function sacarPruebas(){
    const auxPruebas = [];
    const auxPruebasTiempos = [];
    const pruebasTimes = [];
    const pruebas = [];
    for (let i = 0; i < torneoEspecifico.jornadas.length; i++) {
      const auxMaxPruebas = torneoEspecifico.jornadas[i].requisitos.filter((req) => parseInt(req.edadStart) <= edadRegistrada && parseInt(req.edadEnd) >= edadRegistrada)[0]?.maxPruebas;
      for (let j = 0; j < parseInt(auxMaxPruebas ? auxMaxPruebas : 0); j++) {
        const prueba = document.getElementById(`jornada${i}prueba${j}`) !== null ? document.getElementById(`jornada${i}prueba${j}`).value : '';
        const pruebaTiempoMin = document.getElementById(`jornada${i}prueba${j}TiempoMinutos`) !== null ? document.getElementById(`jornada${i}prueba${j}TiempoMinutos`).value !== '' ? document.getElementById(`jornada${i}prueba${j}TiempoMinutos`).value : '0' : '';
        const pruebaTiempoSeg = document.getElementById(`jornada${i}prueba${j}TiempoSegundos`) !== null ? document.getElementById(`jornada${i}prueba${j}TiempoSegundos`).value !== '' ? document.getElementById(`jornada${i}prueba${j}TiempoSegundos`).value : '0' : '';
        const pruebaTiempoMili = document.getElementById(`jornada${i}prueba${j}TiempoMilisegundos`) !== null ? document.getElementById(`jornada${i}prueba${j}TiempoMilisegundos`).value !== '' ? document.getElementById(`jornada${i}prueba${j}TiempoMilisegundos`).value : '0' : '';
        
        const auxTiempos = { 
          prueba: prueba,
          record: pruebaTiempoMin + ':' + pruebaTiempoSeg + ':' + pruebaTiempoMili
        }
        
        auxPruebas.push(prueba);
        auxPruebasTiempos.push(auxTiempos);
      }
    }

    auxPruebas.forEach((auxPrue)=>{
      if(auxPrue !== ''){
        pruebas.push(auxPrue);
      }
    })
    
    auxPruebasTiempos.forEach((auxPrue)=>{
      if(auxPrue.prueba !== ''){
        pruebasTimes.push(auxPrue);
      }
    })
    
    setPruebasTiempos(pruebasTimes);
    setPruebasId(pruebas);
  }

  function validarPruebas(arr) {
    const conjunto = new Set();
    for (const elemento of arr) {
      // Verificar si el elemento no es vacío
      if (elemento !== "") {
        if (conjunto.has(elemento)) {
          // Elemento duplicado encontrado
          return true;
        }
        conjunto.add(elemento);
      }
    }
    // No se encontraron elementos duplicados
    return false;
  }

  function sacarIdentificaciones(ti){
    let identificacion = false;
    if(!modificar){
      deportistas.forEach((deport)=>{
        if(deport.identificacion === ti){
          identificacion = true;
        }
      })
    }

    return identificacion;
  }

  function validarIdentificacion(ti){
    let valido = true;
    if(ti.length < 6 || ti.length > 10 || /^(\d)\1+$/.test(ti)){
      valido = false;
    }
    return valido;
  }

  function validarMaximoPruebas(){
    if(idTorneoParticipando.length !== 0){
      let valido = false;
      torneoEspecifico.jornadas.forEach((jor) =>{
        jor.requisitos.forEach((req) =>{
          if((parseInt(req.edadStart) <= edadRegistrada) && (parseInt(req.edadEnd) >= edadRegistrada) && pruebasId.length <= parseInt(req.maxPruebas)){
            valido = true;
          }
        })
      })
      return valido;
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    const deportistaARegistrar = {
      club: usuario.abreviatura,
      nombre: nombreNadadorMayuscula(e.target.nombre.value),
      identificacion: e.target.identificacion.value,
      fechaNacimiento: e.target.fechaNacimiento.value,
      edad: parseInt(e.target.edad.value),
      genero: e.target.genero.value,
      nombreclub: usuario.nombreclub,
      pruebas: pruebasId,
      categoria: sacarEdadDeLaCategoria(sacarCategoriaInscita(), edadRegistrada, listadoCategorias, listPruebas, pruebasId),
      verificado: e.target.verificacion.value === '' ? 'No Verificado' : e.target.verificacion.value,
      codePais: usuario.codePais,
      departamento: usuario.departamento,
      urlPhoto: e.target.urlPhoto.value !== '' ? e.target.urlPhoto.value : '',
      urlPhotoEq: usuario.photo !== null ? usuario.photo : ''
    }
    if(validarPruebas(deportistaARegistrar.pruebas)){
      toast.error('Al parecer intentas registrar al deportista en 2 o mas pruebas iguales, eso no es posible, por favor verifica para poder continuar.');
    }else if(deportistaARegistrar.pruebas.length === 1 && deportistaARegistrar.pruebas[0] === ''){
      toast.error('No has seleccionado las pruebas todavía. En caso de que las hayas elegido y el sistema no te permita avanzar. Por favor, recarga la plataforma.');
    }else{
      if(sacarIdentificaciones(deportistaARegistrar.identificacion) || !validarIdentificacion(deportistaARegistrar.identificacion)){
        if(sacarIdentificaciones(deportistaARegistrar.identificacion)){
          toast('Ya existe un/una deportista con esta identificación ' + deportistaARegistrar.identificacion,{
            icon: '🤨'
          })
        }
        if(!validarIdentificacion(deportistaARegistrar.identificacion)){
          toast('Esta identificación ' + deportistaARegistrar.identificacion + ' no es valida',{
            icon: '🤨'
          })
        }
      }else{
        if(modificar){
          if(deportistaARegistrar.pruebas.length === 0){
            toast('Debes hacer una modificación en las pruebas o darle clic en una de las pruebas.',{
              icon: '🤨'
            })
          }else{
            organizarPorTiempos(deportistaARegistrar.identificacion, pruebasTiempos, mostrarJornadas, torneoEspecifico?.piscina).then((org)=>{
              deportistaARegistrar.records = org;
              registrarNadador(idTorneoParticipando, deportistaARegistrar);
            });
            if(deportistaARegistrar.edad >= 5){
              registrarDeportistaGeneral(deportistaARegistrar.identificacion, deportistaARegistrar, usuario.departamento);
            }
            setEdadRegistrada();
            setDeportistaGeneral();
            setMostrarJornadas([]);
            setPruebasId([]);
            setModificar(false);
            e.target.reset();
          }
        }else{
          organizarPorTiempos(deportistaARegistrar.identificacion, pruebasTiempos, mostrarJornadas, torneoEspecifico?.piscina).then((org)=>{
            deportistaARegistrar.records = org;
            registrarNadador(idTorneoParticipando, deportistaARegistrar);
          });
          if(deportistaARegistrar.edad >= 5){
            registrarDeportistaGeneral(deportistaARegistrar.identificacion, deportistaARegistrar, usuario.departamento);
          }
          deportistaRegistradoPWS(datosAdmin.conexion, torneoEspecifico.id);
          setEdadRegistrada();
          setDeportistaGeneral();
          setMostrarJornadas([]);
          setPruebasId([]);
          setModificar(false);
          e.target.reset();
        }
      }
    }
  };

  const onSubmitRelevo = (e) => {
    e.preventDefault();
    let relevosVacios = false;

    inputsDeportistasRelevos.forEach((inp) =>{
      if(inp.name === ''){
        relevosVacios = true;
      }
    })
    
    if(inputsDeportistasRelevos.length !== 0 && !relevosVacios){
      let deportista1 = {};
      const identificacionEquipo = [];
      const nombresEquipo = [];
      const edades = [];
      inputsDeportistasRelevos.forEach((deport)=>{
        const deportista = deportistas.filter((depor) => depor.nombreclub === usuario.nombreclub && depor.identificacion === deport.doc)[0]
        deportista1 = deportista;
        identificacionEquipo.push(deportista.identificacion);
        nombresEquipo.push(deportista.nombre);
        edades.push(deportista.edad);
      })

      const auxEdad = esRelevoMaster ? edades.reduce((acumulador, elemento) => acumulador + elemento, 0) : relevoEdadInicioFin.edadI;
      const deportistaARegistrar = {
        club: usuario.abreviatura,
        nombre: usuario.nombreclub,
        identificacion: `${identificacionEquipo}`,
        fechaNacimiento: '',
        edad: auxEdad,
        edades: edades,
        genero: relevos[elegirRelevos].filter((rel) => rel.id === parseInt(relevoElegido))[0]?.genero,
        nombreclub: usuario.nombreclub,
        pruebas: [relevos[elegirRelevos].filter((rel) => rel.id === parseInt(relevoElegido))[0]?.prueba.id],
        categoria: sacarEdadDeLaCategoria([relevos[elegirRelevos].filter((rel) => rel.id === parseInt(relevoElegido))[0]?.categoriaDeportistas], auxEdad, listadoCategorias, listPruebas, [relevos[elegirRelevos].filter((rel) => rel.id === parseInt(relevoElegido))[0]?.prueba.id]),
        equipo: nombresEquipo,
        records: [
          {prueba: relevos[elegirRelevos].filter((rel) => rel.id === parseInt(relevoElegido))[0]?.prueba.id,
           record: '0:0:0'}
        ],
        codePais: usuario.codePais,
        departamento: usuario.departamento,
        ocultar: visibilidadRelevos
      }

      if(!validarPruebas(deportistaARegistrar.equipo)){
        const auxNadadoresRelevos = [...nadadoresRelevo]; 
        auxNadadoresRelevos.push(deportistaARegistrar);
        registrarRelevo(idTorneoParticipando, auxNadadoresRelevos, usuario.id, 'registrar');
      }else{
        toast.error('Se encontro un deportista repetido. Por favor verifica.');
      }
    }else{
      toast.error('Llena todos los campos.');
    }
  }
  
  const buscarDeportista = (event) => {
    const regex = new RegExp(event.target.value, "i");
    const auxBusquedaListNombres = listNombresRanking.filter(item => regex.test(item.nombre));
    setBusquedaListNombresRanking(auxBusquedaListNombres);
  }

  const deportistaSeleccionado = (ti) => {
    const auxDeportista = listNombresRanking.filter(item => item.identificacion === ti)[0];
    if(auxDeportista){
      const auxObjDeportista = {
        club: auxDeportista.club,
        edad: calcularEdad(auxDeportista.fechaNacimiento),
        nombre: auxDeportista.nombre,
        fechaNacimiento: auxDeportista.fechaNacimiento,
        genero: auxDeportista.genero,
        identificacion: auxDeportista.identificacion,
        verificado: auxDeportista.verificado,
        urlPhoto: auxDeportista.urlPhoto ? auxDeportista.urlPhoto : ''
      }
      setDeportistaGeneral(auxObjDeportista);
      setEdadRegistrada(calcularEdad(auxObjDeportista.fechaNacimiento));
      document.getElementById('nombre').value = auxObjDeportista.nombre;

      if (misDeportistasRef.current) {
        misDeportistasRef.current.hide();
      }
    }
  }

  function anadirCamposDirectivo(index){
    const auxDirectivos = [...directivos];
    if(auxDirectivos.length < parseInt(torneoEspecifico.jornadas[0].cantDirectivos)){
      const auxObjDirectivo = {id: 0, nombre: '', cel: '', rol: ''};
      auxDirectivos.splice(index + 1, 0, auxObjDirectivo);
      setDirectivos(auxDirectivos);
    }
  }

  function quitarCamposDirectivo(index){
    const auxDirectivos = [...directivos];
    if(auxDirectivos.length > 1){
      auxDirectivos.splice(index, 1);
      setDirectivos(auxDirectivos);
    }
  }

  function registrarDirectivos(){
    let auxDirectivos = [...directivos];
    for (let i = 0; i < directivos.length; i++) {
      const nombreDire = document.getElementById(`nombreDirectivo${i}`) !== null ? document.getElementById(`nombreDirectivo${i}`).value : '';
      const celDire = document.getElementById(`cel${i}`) !== null ? document.getElementById(`cel${i}`).value : '';
      const rolDire = document.getElementById(`rol${i}`) !== null ? document.getElementById(`rol${i}`).value : '';

      auxDirectivos[i].id = 0;
      auxDirectivos[i].nombre = nombreNadadorMayuscula(nombreDire);
      auxDirectivos[i].cel = celDire;
      auxDirectivos[i].rol = rolDire;

      if(nombreDire !== '' && rolDire !== ''){
        switch (rolDire) {
          case 'Entrenador/a Principal':
            auxDirectivos[i].id = 1;
            break;
          case 'Entrenador/a':
            auxDirectivos[i].id = 2;
            break;
          case 'Delegado/a':
            auxDirectivos[i].id = 3;
            break;
          case 'Monitor/a':
            auxDirectivos[i].id = 4;
            break;
          case 'Medico':
            auxDirectivos[i].id = 5;
            break;
          case 'Fisioterapeuta':
            auxDirectivos[i].id = 6;
            break;
          case 'Logistica':
            auxDirectivos[i].id = 7;
            break;
          default:
            break;
        }
      }
    }
    
    if(torneoEspecifico.jornadas[0].cantDirectivos >= directivos.length){
      setDirectivos(auxDirectivos);
      registrarDirectivosClub(usuario.id, auxDirectivos, torneoEspecifico.id);
    }else{
      toast.error(`Has excedido el límite máximo de directivos permitidos, máximo (${torneoEspecifico.jornadas[0].cantDirectivos}).`);
      return;
    }

    const aux = [...usuario.directivos];
    auxDirectivos.forEach((auxDire)=>{
      if(auxDire.nombre !== '' && auxDire.rol !== ''){
        const indexDire = aux.findIndex((dire)=> dire.nombre === auxDire.nombre);
        if(indexDire !== -1){
          aux[indexDire] = auxDire;
        }else{
          aux.push(auxDire);
        }
      }
    })

    aux.sort((a, b) => a.id - b.id);
    usuario.directivos = aux;
    registrarDirectivosPws(usuario, aux);
  }

  function recordsPruebas(prue, auxDeportista){
    let auxRecord = ': 0:0:0';
    if(auxDeportista){
      const auxPrueba = auxDeportista.pruebas.find(prueDeport => prueDeport.piscina === torneoEspecifico.piscina && prueDeport.prueba === prue.prueba);
      if(auxPrueba){
        auxRecord = ': ' + auxPrueba.record;
      }
    }
    return auxRecord;
  }

  function pruebasExtras(cant, prueba, indexPrueba){
    const ti = document.getElementById('identificacion').value;
    const auxDeportista = listNombresRanking.find(list => list.identificacion === ti);
    const auxCantPruebas = Array.from({ length: cant}, (_, index) => index);
     return auxCantPruebas.map((items, indexPrueExtra)=>(
      <tr key={indexPrueExtra}>
        <td>
          <div className="form-floating mb-2">
            <select style={{minWidth: '100px'}} className='form-select' id={`jornada${indexPrueba}prueba${indexPrueExtra}`} defaultValue={modificar ? deportistaGeneral['records' + indexPrueba][indexPrueExtra] ? deportistaGeneral['records' + indexPrueba][indexPrueExtra].prueba : '' : '0'} onChange={() => sacarPruebas()}>
              <option value=''>{`Ninguna`}</option>
              {
                prueba.pruebas.map((prue, indexPrue)=>{
                  return <option disabled={pruebasId.includes(prue.id)} className={`${pruebasId.includes(prue.id) ? 'bg-danger text-light' : ''}`} key={indexPrue} value={prue.id}>{prue.prueba + recordsPruebas(prue, auxDeportista) + ' - ' + prue.categoria}</option>
                })
              }
            </select>
            <label htmlFor="genero">{prueba.pruebas.length} Pruebas Disponibles</label>
          </div>
        </td>
        <td className='d-flex justify-content-around align-items-center'>
          <div className="form-floating pb-2">
            <input style={{width: '68px'}} disabled={torneoEspecifico.regTiempo === 'no' ? true : false} type="number" id={`jornada${indexPrueba}prueba${indexPrueExtra}TiempoMinutos`} className='form-control' placeholder='0' defaultValue={modificar ? parseInt(deportistaGeneral['records' + indexPrueba][indexPrueExtra] ? deportistaGeneral['records' + indexPrueba][indexPrueExtra].record[0] : 0) : '0'} onChange={() => sacarPruebas()}/>
            <label htmlFor="deportCC">Min.</label>
          </div>
          <div className="form-floating pb-2">
            <input style={{width: '68px'}} disabled={torneoEspecifico.regTiempo === 'no' ? true : false} type="number" id={`jornada${indexPrueba}prueba${indexPrueExtra}TiempoSegundos`} className='form-control' placeholder='0' defaultValue={modificar ? parseInt(deportistaGeneral['records' + indexPrueba][indexPrueExtra] ? deportistaGeneral['records' + indexPrueba][indexPrueExtra].record[1] : 0) : '0'} onChange={() => sacarPruebas()}/>
            <label htmlFor="deportCC">Seg.</label>
          </div>
          <div className="form-floating pb-2">
            <input style={{width: '68px'}} disabled={torneoEspecifico.regTiempo === 'no' ? true : false} type="number" id={`jornada${indexPrueba}prueba${indexPrueExtra}TiempoMilisegundos`} className='form-control' placeholder='0' defaultValue={modificar ? parseInt(deportistaGeneral['records' + indexPrueba][indexPrueExtra] ? deportistaGeneral['records' + indexPrueba][indexPrueExtra].record[2] : 0) : '0'} onChange={() => sacarPruebas()}/>
            <label htmlFor="deportCC">Mili.</label>
          </div>
        </td>
      </tr>
     ))
  }

  const header = (
    <div className="d-flex justify-content-start align-items-center">
      <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
      </span>
    </div>
  );

  const agregarInscrito = () => {
    return (
      <div className="flex flex-wrap gap-2">
        {torneoEspecifico?.evento !== 'finales' && !torneoEspecifico?.inscripcionesCerradas ?(
          <Button icon="pi pi-plus" severity="success" raised tooltip='Inscribir' tooltipOptions={{position: 'right', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => setDialogInscripcion(true)}/>
        ):(
          <></>
        )}
        <Button className='ms-1 me-1' icon="pi pi-flag" severity="warning" raised tooltip='Relevos' tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => setDialogRelevos(true)}/>
        <Button className='me-1' icon="pi pi-file-pdf" severity="danger" raised tooltip='Reporte .pdf' tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => reporteInscritos(pruebasCompletas, usuario, nadadores, nadadoresRelevo, setPdfUrl, torneoEspecifico)}/>
        <Button className='me-1' icon="pi pi-users" severity="primary" raised tooltip='Directivos' tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => setDialogDirectivos(true)}/>
        <Button className='me-1' icon="pi pi-images" severity='secondary' raised tooltip='Fotos Deportistas' tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => setDialogFotosDeportistas(true)}/>
        <i className="pi pi-envelope p-overlay-badge border border-dark rounded-circle p-3" style={{ fontSize: '17px', cursor: "pointer" }} onClick={() => setDialogMensajes(true)}>
          <Badge value={mensajes.length <= 10 ? mensajes.length : '10+'} severity="danger"></Badge> 
        </i>
      </div>
    );
  };

  function sacarPruebasTiempos(nadador){
    const auxPrueba = [];
    nadador.records.forEach((prue)=>{
      const prueba = listPruebas.filter((listPrue)=>{return listPrue.id === prue.prueba});
      prue.nombre = prueba[0].prueba;
      auxPrueba.push(prue);
    })
    return auxPrueba;
  }

  const rowExpansionTemplate = (data) => {
    return (
      <DataTable value={sacarPruebasTiempos(data)} emptyMessage="No hay pruebas registradas.">
        <Column header="#" body={(_, index)=>{return index.rowIndex + 1}} style={{ width: '30px'}}></Column>
        <Column field="nombre" header="Prueba" style={{ width: '110px'}}></Column>
        <Column field="record" header="Tiempo" style={{ width: '80px'}}></Column>
      </DataTable>
    );
  };

  const acciones = (insc) => {
    return (
      <div>
        {torneoEspecifico?.evento !== 'finales' ?(
          <Button icon="pi pi-pencil" size='small' text severity="secondary" tooltip='Editar' tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => modificarInscrito(insc)}/>
        ):(
          <></>
        )}
        <Button text icon="pi pi-times" size='small' severity="danger" tooltip='Eliminar' tooltipOptions={{position: 'left', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '50%'}} onClick={() => clickNadador(insc)}/>
      </div>
    );
  };

  const subirPdf = (event, insc) =>{
    const selectedFile = event.target.files[0];
    extraerDatosPdf(selectedFile, insc, idTorneoParticipando);
    const fileInput = document.getElementById(`subirPdf${insc.identificacion}`);
    fileInput.value = '';
  }

  const accionesVerificacion = (insc) => {
    if(!insc.verificado){
      return (
        <div>
          <input type="file" id={`subirPdf${insc.identificacion}`} hidden onChange={(ev) => subirPdf(ev, insc)}/>
          <label htmlFor={`subirPdf${insc.identificacion}`}><i title='Verificar' className="pi pi-id-card text-danger" style={{cursor: 'pointer'}}></i></label>
        </div>
      );
    }else{
      if(insc.verificado === 'No Verificado'){
        return (
          <div>
            <input type="file" id={`subirPdf${insc.identificacion}`} hidden onChange={(ev) => subirPdf(ev, insc)}/>
            <label htmlFor={`subirPdf${insc.identificacion}`}><i title='Verificar' className="pi pi-id-card text-danger" style={{cursor: 'pointer'}}></i></label>
          </div>
        );
      }else{
        return (
          <div>
            <label><i title='Verificado/a' className="pi pi-id-card text-success"></i></label>
          </div>
        );
      }
    }
  };

  function clickNadador(insc){
    const alerta = Swal.mixin({
      toast: true,
      showCancelButton: true
    })
    alerta.fire({
      html: `<div class="w-100 position-relative">
      <img style="width: 100px; position: absolute; top: 10px; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
      <p style="z-index: 10; font-family: Poppins" class="mb-0">Esta seguro de eliminar a el/la deportista ${insc.nombre}
      </div>`,
      confirmButtonText: 'Confirmar',
      confirmButtonColor: 'rgb(18, 53, 248)',
      padding: 4,
      cancelButtonText: 'Cancelar',
    }).then((respuesta) =>{ 
      if(respuesta.isConfirmed){
        eliminarNadador(insc, idTorneoParticipando);
        deportistaEliminadoPWS(datosAdmin.conexion, torneoEspecifico.id);
      }
    })
  }

  function eliminarNadadorRelevo(index){
    const alerta = Swal.mixin({
      toast: true,
      showCancelButton: true
    })
    alerta.fire({
      html: `<div class="w-100 position-relative">
      <img style="width: 100px; position: absolute; top: 10px; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
      <p style="z-index: 10; font-family: Poppins" class="mb-0">Esta seguro de eliminar el relevo
      </div>`,
      confirmButtonText: 'Confirmar',
      confirmButtonColor: 'rgb(18, 53, 248)',
      padding: 4,
      cancelButtonText: 'Cancelar',
    }).then((respuesta) =>{
      if(respuesta.isConfirmed){
        const auxNadadoresRelevo = [...nadadoresRelevo]
        auxNadadoresRelevo.splice(index, 1);
        registrarRelevo(idTorneoParticipando, auxNadadoresRelevo, usuario.id, 'eliminar');
      }
    })
  }

  function modificarInscrito(insc){
    setDialogInscripcion(true);
    torneoEspecifico.jornadas.forEach((jor, indexJor)=>{
      const auxRecords = []; 
      jor.pruebas.forEach((prueJor)=>{
        insc.records.forEach((inscPrue)=>{
          if(prueJor.idPrueba === inscPrue.prueba){
            auxRecords.push(inscPrue);
          }
        })
      })

      insc['records' + indexJor] = auxRecords;
      insc['records' + indexJor].forEach((rec)=>{
        rec.record = rec.record.length !==  3 ? rec.record.split(':') : rec.record;
      })
    })
    setEdadRegistrada(calcularEdad(insc.fechaNacimiento));
    setDeportistaGeneral(insc);
    setModificar(true);
  }

  const footerGroupDeportista = (
    <ColumnGroup>
      <Row>
        <Column footer="Total:" colSpan={8} footerStyle={{ textAlign: 'right' }} />
        <Column footer={nadadores.length !== 0 ? ((deportistas.filter((depor)=>depor.nombreclub === usuario.nombreclub).length * (torneoEspecifico.length !== 0 ? parseInt(torneoEspecifico.valorDeportista) : 0)) + (torneoEspecifico.length !== 0 ? parseInt(torneoEspecifico.valorClub) : 0)).toLocaleString() :(0)} />
      </Row>
    </ColumnGroup>
  );

  function sacarCantidadPruebas(jor){
    let auxPruebas = 0;
    jor.requisitos.forEach((req)=>{
      if(parseInt(req.edadStart) <= edadRegistrada && parseInt(req.edadEnd) >= edadRegistrada){
        auxPruebas = parseInt(req.cantPruebas);
      }
    })
    return auxPruebas;
  }

  function agregarDatosAlInputs(valor, index){
    const auxDeportistaRelevo = [...inputsDeportistasRelevos];
    auxDeportistaRelevo[index] = valor;
    setInputsDeportistasRelevos(auxDeportistaRelevo);
  }

  const content = (
    <div className="d-flex align-items-center"> 
      <img alt="logo" src={require("../img/img-logo-swimmingt.webp")} width="50" />
      <div className="ms-2 text-danger text-start">Sin Pruebas: <b>{nadadoresSinPruebas.toLocaleString()}</b></div>
    </div>
  );

  const contentDirectivos = (
    <div className="d-flex align-items-center"> 
      <img alt="logo" src={require("../img/img-logo-swimmingt.webp")} width="50" />
      <div className="ms-2 text-danger text-start">No tienes directivos registrados aún. <b>Agrégalos</b> haciendo clic en el botón azul.</div>
    </div>
  );

  const contentVerificados = (
    <div className="d-flex align-items-center"> 
      <img alt="logo" src={require("../img/img-logo-swimmingt.webp")} width="50" />
      <div className="ms-2 text-danger text-start"><b>{nadadores.filter((nad)=>nad.verificado === 'No Verificado').length} Deportistas No Verificados</b> — Te invitamos a comenzar su verificación. Pronto será requisito para participar, <b>¡aprovecha y avanza desde ya!</b></div>
    </div>
  );

  function arreglarFecha(fecha){
    const fechaActualizada = new Date(fecha).toLocaleString('es-ES',{ 
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      weekday: 'long'
    });
    return fechaActualizada;
  }

  function enviarMensaje(){
    const mensaje = document.getElementById('mensaje').value;
    const date = new Date(fechaGoogle);
    const fechaPc = new Date();
    // Extraer y formatear la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son 0-11
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(fechaPc.getHours()).padStart(2, '0');
    const minutes = String(fechaPc.getMinutes()).padStart(2, '0');
    const second = String(fechaPc.getSeconds()).padStart(2, '0');

    // Crear la cadena en el formato deseado
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${second}`;
    const objMensaje = { 
      mensaje,
      photo: usuario.photo,
      nombreclub: usuario.nombreclub,
      fecha: formattedDateTime + "",
      id: ''
    }

    try {
      registrarMensaje(idTorneoParticipando, objMensaje);
      document.getElementById('mensaje').value = "";
      traerTokensNotificacionInscripciones().then((token)=>{
        token.forEach((tk)=>{
          notificacion(tk, `${usuario.nombreclub} dice: ${objMensaje.mensaje}`, `${torneoEspecifico.titulo} - ${datosAdmin.nombre}`).catch(() =>{
            eliminarTokenNotificacion(tk.token);
          });
        })
      })
    } catch (error) {
      toast.success("¡Ups! Ocurrio un error. Intentalo de nuevo.");
    }
  }

  const cargarFoto = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
  }

  const quitarFondo = async () => {
    const img = new Image();
    img.src = preview;
  
    img.onload = async () => {
      const canvas = resizeImage(img, 512);
  
      // Convert to Blob (always PNG for transparency)
      canvas.toBlob(async (blob) => {
        if (!blob) return;
  
        const formData = new FormData();
        formData.append('image', blob, 'resized.png');
  
        setCargandoRecorte(true);
        const res = await fetch('https://servidor.prowebsports.com.co/remove-bg', {
          method: 'POST',
          body: formData,
        }).catch((err) =>{
          setCargandoRecorte(false);
        });

        if (res?.ok) {
          const blobResult = await res.blob();
          setBlobFoto(blobResult);
          setPreview(URL.createObjectURL(blobResult));
          setCargandoRecorte(false);
          setFotoSinFondo(true);
        } else {
          toast.error('Ups, no pudimos quitar el fondo. La IA funciona de 8:00 a.m. a 8:00 p.m. Escríbenos si necesitas ayuda 😊');
        }
      }, 'image/png');
    };
  };

  function recortarArea() {
    const pixelCrop = areaPixels;
    const image = new Image();
    image.src = preview;
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    canvas.toBlob((blob) => {
      const croppedImageUrl = URL.createObjectURL(blob);
      setBlobFoto(blob);
      setPreview(croppedImageUrl);
      setFotoRecortada(true);
    }, 'image/png');
  }

  function deportistaElegido(depor){
    setPreview(null);
    setFotoRecortada(false);
    setFotoSinFondo(false);
    setBlobFoto(null);
    setDeportistaSelectRanking(depor);
  }
  
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setAreaPixels(croppedAreaPixels);
  }, []);

  useEffect(() => {
    traerDeportistas(idTorneoParticipando, setDeportistas);
    traerDeportistaRanking(usuario.nombreclub, setListNombresRanking);
    traerRelevosEquipo(idTorneoParticipando, usuario.id, setNadadoresRelevo); 
  }, [])

  useEffect(() => {
    if(!dialogInscripcion){
      setEdadRegistrada();
      setDeportistaGeneral();
      setMostrarJornadas([]);
      setModificar(false);
      setPruebasId([]);
    }
  }, [dialogInscripcion])

  useEffect(() => {
    if(!dialogRelevos || elegirRelevos){
      setListaDeportistasRelevo([]);
      setRelevoElegido('');

      if(!dialogRelevos){
        setElegirRelevos(-1);
      }
    }
  }, [dialogRelevos, elegirRelevos])

  useEffect(() => {
    if(usuario.nombreclub === datosAdmin.nombre || usuario.nombreclub === 'PROWEBSPORTS'){
      abrirBaseDeDatosLocal(idTorneoParticipando);
      verificarLimpiar(idTorneoParticipando);
    }

    function registrarClub(){
      const club = {
        idClub: usuario.id,
        abreviatura: '',
        email: usuario.email,
        relevos: [],
        nombreclub: usuario.nombreclub,
        photo: usuario.photo,
        codePais: usuario.codePais,
        departamento: usuario.departamento
      }
      registrarClubAlTorneo(idTorneoParticipando, club, usuario.id, usuario.photo, torneoEspecifico);
    }

    registrarClub();
    traerPruebasParaRegistroJPC(setListPruebas);
    traerDirectivos(torneoEspecifico.id, usuario.id, setDirectivos, setDialogDirectivos);
    traerMensajes(idTorneoParticipando, setMensajes);
  }, [usuario, idTorneoParticipando])

  useEffect(() => {
    setNadadores(deportistas.filter((depor)=>depor.nombreclub === usuario.nombreclub));
  }, [deportistas])

  useEffect(() =>{
    if(modificar && !dialogInscripcion || !pdfUrl){
      const auxNadadores = [...nadadores];
      const nuevoNadadores = [];
      auxNadadores.forEach((auxNad)=>{
        const objNadador = {
          club: auxNad.club,
          edad: auxNad.edad,
          fechaNacimiento: auxNad.fechaNacimiento,
          genero: auxNad.genero,
          identificacion: auxNad.identificacion,
          nombre: auxNad.nombre,
          nombreclub: auxNad.nombreclub,
          pruebas: auxNad.pruebas,
          records: [],
          categoria: auxNad.categoria,
          verificado: auxNad.verificado,
          codePais: auxNad.codePais,
          departamento: auxNad.departamento,
          verificado: auxNad.verificado,
          urlPhoto: auxNad.urlPhoto,
          urlPhotoEq: auxNad.urlPhotoEq,
        }
        auxNad.records.forEach((rec)=>{
          const objRecord = {
            prueba: rec.prueba
          }
          if(rec.record.length === 3){
            objRecord.record = `${rec.record[0]}:${rec.record[1]}:${rec.record[2]}`
          }else{
            objRecord.record = rec.record;
          }

          objNadador.records.push(objRecord);
        })

        nuevoNadadores.push(objNadador);
      })

      setNadadores(nuevoNadadores);
    }
    if(!dialogInscripcion){
      setBusquedaListNombresRanking([]);
    }
  },[dialogInscripcion, modificar, pdfUrl])

  useEffect(() => {
    function sacarPruebasRelevos(){
      const relevosEncontrados = [];
      pruebasCompletas.forEach((pruebas)=>{
        const auxRelevos = [];
        pruebas.forEach((prue)=>{
          const relevo = prue.prueba.prueba.match(/Relevo/g);
          if(relevo){
            auxRelevos.push(prue);
          }
        })
        relevosEncontrados.push(auxRelevos);
      })
      setRelevos(relevosEncontrados);
    }

    sacarPruebasRelevos();
  }, [dialogRelevos])

  useEffect(() =>{
    if(!dialogFotosDeportistas){
      setPreview(null);
      setDeportistaSelectRanking();
      setBlobFoto(null);
      setCargandoRecorte(false);
      setFotoRecortada(false);
      setFotoSinFondo(false);
    }
  },[dialogFotosDeportistas])

  useEffect(() =>{
    if(deportistaSelectRanking){
      if (misDeportistasRef.current) {
        misDeportistasRef.current.hide();
      }
    }
  },[deportistaSelectRanking])

  useEffect(() =>{
    function anadirInputDeportistaRelevo(){
      const auxDeportista = [...inputsDeportistasRelevos];
      const inputsNuevo = {
        name: '',
        code: '',
        doc: '',
        edad: 0
      };
  
      Array.from({ length: 4 }, (_, index) => index).forEach((indexRel) =>{
        auxDeportista[indexRel] = inputsNuevo; 
      })
      setInputsDeportistasRelevos(auxDeportista);
    }

    function edadesPrueba(){
      const auxDeportistasNombres = [];
      if(relevoElegido !== ''){
        const aux = [];
        let relevoMaster = false;
        const auxRelevoEdadInicioFin = relevoEdadInicioFin;

        pruebasCompletas.forEach((prue)=>{
          const auxPrueba = prue.filter((auxPrue)=>{return auxPrue.id === parseInt(relevoElegido)});
          if(auxPrueba.length !== 0){
            if(/\brelevo master\b/i.test(auxPrueba[0].categoria)){
              relevoMaster = true;
            }
            aux.push(auxPrueba[0]);
            auxRelevoEdadInicioFin.edadI = parseInt(auxPrueba[0].edadInicio);
            auxRelevoEdadInicioFin.edadF = parseInt(auxPrueba[0].edadFin);
            setRelevoEdadInicioFin(auxRelevoEdadInicioFin);
          }
        })
        if(aux.length !== 0){
          if(deportistas.filter((depor) => depor.nombreclub === usuario.nombreclub && (parseInt(aux[0].edadFin) >= depor.edad)).length !== 0){
            deportistas.filter((depor) => depor.nombreclub === usuario.nombreclub && (parseInt(aux[0].edadFin) >= depor.edad)).forEach((deport, indexDeport)=>{
              const objDeport = {
                name: `${deport.nombre}/${deport.edad} años/${deport.nombreclub}`,
                code: indexDeport,
                doc: deport.identificacion,
                edad: deport.edad
              };
              auxDeportistasNombres.push(objDeport);
            })
          }
        }
        setListaDeportistasRelevo(auxDeportistasNombres);
        anadirInputDeportistaRelevo();
        setEsRelevoMaster(relevoMaster);
      }
    }

    edadesPrueba();
    anadirInputDeportistaRelevo();
  },[relevoElegido])

  useEffect(() =>{
    const auxNadadoresSinPruebas = [];
    nadadores.forEach((nad)=>{
      if(nad.pruebas.length === 0){
        auxNadadoresSinPruebas.push(nad.nombre)
      }
    })

    if(auxNadadoresSinPruebas.length !== 0){
      setNadadoresSinPruebas(auxNadadoresSinPruebas);
    }else{
      setNadadoresSinPruebas([]);
    }
  },[nadadores])

  return (
    <>
      <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{duration: 1}}
      >
        <div className='bg-light'>
          <div className="alert alert-success alert-dismissible fade show mb-0 pe-3 pb-0" role="alert">
            <h1>{torneoEspecifico.titulo ? torneoEspecifico.titulo.toUpperCase() : ''}</h1>
            <p style={{textAlign: 'justify'}}>
              <b>Asegura la confianza y transparencia en la participación de tus deportistas. </b>
              Verifica la edad de cada deportista sin necesidad de presentar tarjetas de identidad o cédulas durante el evento. 
              Simplemente haz clic en el ícono de la tarjeta junto al nombre de cada niñ@ no verificad@ y sube el archivo correspondiente en formato PDF o Imagen. 
              Nuestro sistema extraerá automáticamente la información necesaria del documento, garantizando un registro eficiente y una experiencia sin complicaciones. 
              <b> Cabe destacar que el documento no será almacenado en la plataforma. </b><button className='btn btn-info' onClick={(e) => pdfEjemplo.current.toggle(e)}>Ejemplo</button>
            </p> 
            <OverlayPanel ref={pdfEjemplo}>
              <div className='d-flex flex-column'>
                <img src={require('../img/img-cedula-ejemplo.png')} alt="img ejemplo" style={{width: '100px'}}></img>
              </div>
            </OverlayPanel>  
          </div>
          <Toolbar left={agregarInscrito}></Toolbar>
          {directivos[0].nombre === '' ? (
            <div className="card">
              <Message
                style={{
                    border: 'solid #696cff',
                    borderWidth: '0 0 0 6px',
                    color: '#696cff'
                }}
                className="border-danger justify-content-start"
                severity="error"
                content={contentDirectivos}
            />
            </div>
          ):(
            <></>
          )}
          {nadadores.filter((nad)=> nad.verificado === 'No Verificado').length !== 0 ? (
            <div className="card">
              <Message
                style={{
                    border: 'solid #696cff',
                    borderWidth: '0 0 0 6px',
                    color: '#696cff'
                }}
                className="border-danger justify-content-start"
                severity="error"
                content={contentVerificados}
            />
            </div>
          ):(
            <></>
          )}
          {nadadoresSinPruebas.length !== 0 ? (
            <div className="card">
              <Message
                style={{
                    border: 'solid #696cff',
                    borderWidth: '0 0 0 6px',
                    color: '#696cff'
                }}
                className="border-danger justify-content-start"
                severity="error"
                content={content}
            />
            </div>
          ):(
            <></>
          )}
          <DataTable value={nadadores} selectionMode="single" dragSelection expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)} rowExpansionTemplate={rowExpansionTemplate} header={header} globalFilter={globalFilter} size='small' stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} emptyMessage="No hay inscritos aún." 
          footerColumnGroup={footerGroupDeportista} tableStyle={{ minWidth: '62rem', margin: 'auto'}}>
            <Column expander style={{ width: '30px' }} />
            <Column header="#" body={(_, index)=>{return index.rowIndex + 1}} style={{ width: '30px'}}></Column>
            <Column body={(insc)=> accionesVerificacion(insc)} style={{ width: '10px'}}></Column>
            <Column field='nombre' sortable header="Nombre" body={(nadador) => nadador.pruebas.length !== 0 ? nadador.nombre : <>{nadador.nombre}<i className='ms-1 pi pi-times-circle text-danger'/></>} style={{ width: torneoEspecifico?.inscripcionesCerradas ? '220px' : '180px', fontWeight: 'bold' }}></Column>
            <Column field="identificacion" sortable header="Identificación" style={{ width: '70px'}}></Column>
            <Column field="fechaNacimiento" sortable header="Fec. Nto" style={{ width: torneoEspecifico?.inscripcionesCerradas ? '150px' : '110px'}}></Column>
            <Column field="edad" header="Edad" sortable style={{ width: '50px'}}></Column>
            <Column field="genero" header="Sexo" sortable style={{ width: '50px'}}></Column>
            <Column header="Aporte" body={() => {return `$${torneoEspecifico.length !== 0 ? parseInt(torneoEspecifico.valorDeportista).toLocaleString() : 0}`}} style={{ width: '80px'}}></Column>
            {!torneoEspecifico?.inscripcionesCerradas ?(
              <Column body={(insc)=> acciones(insc)} style={{ width: '105px'}}></Column>
            ):(
              <></>
            )}
          </DataTable>
        </div>
        <Dialog visible={dialogInscripcion} maximizable style={{ width: '46rem' }} breakpoints={{ '960px': '75vw', '641px': '100%' }} header='INSCRIPCIÓN' modal className="p-fluid" onHide={() => setDialogInscripcion(false)}>
          <div className="field">
          <form onSubmit={onSubmit} className='text-center'>
            <input className='form-control' type="hidden" name="edad" id='edad' value={edadRegistrada || ''}/>
            <div className="alert alert-secondary alert-dismissible fade show mb-1 p-1" role="alert">
              <b>Edad Inscrito: </b>{deportistaGeneral?.verificado === 'Verificado' ? <Tag severity={'success'} icon={'pi pi-user'} value={(edadRegistrada || '0') + ' Años Verificado'}></Tag> : <Tag severity={'danger'} icon={'pi pi-user'} value={(edadRegistrada || '0') + ' Años No Verificado'}></Tag>}
            </div>
            <hr className='m-1'/>
            <div className='m-auto d-flex flex-wrap justify-content-between' style={{maxWidth: '800px'}}>
              <div className="m-1 form-floating" style={{width: window.innerWidth <= 500 ? '100%' : '270px'}}>
                <input autocomplete="off" className='form-control' type="text" maxLength={29} name="nombre" id='nombre' required defaultValue={deportistaGeneral ? deportistaGeneral.nombre : ''} onChange={buscarDeportista} onClick={(e) => misDeportistasRef.current.toggle(e)}/>
                <OverlayPanel ref={misDeportistasRef}>
                  <div style={{height: '300px', overflow: 'auto'}}>
                    <h4 className='text-center'>{listNombresRanking.length} Deportistas</h4>
                    <hr className='m-0'/>
                    {busquedaListNombresRanking.length !== 0 ?(
                      busquedaListNombresRanking.map((nombre, indexNombre)=>{
                        return <div key={indexNombre} style={{cursor: "pointer"}} onClick={() => deportistaSeleccionado(nombre.identificacion)}>
                          <div className='d-flex' style={{ background: nadadores.some(nad => nad.identificacion === nombre.identificacion) ? '#E7FEEB' : 'white' }}>
                            <div style={{width: '32px', height: '42px'}}>
                              <img className='me-1 py-1 w-100 h-100' src={nombre?.urlPhoto && nombre?.urlPhoto !== '' ? nombre.urlPhoto : nombre?.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{filter: 'drop-shadow(0 0 1px black)', objectFit: 'contain'}}/>
                            </div>
                            <div>
                              <p className='mb-0 d-flex align-items-center'><b>{nombre.nombre}</b>{nombre.verificado ? nombre.verificado === 'Verificado' ? <i className='pi pi-verified ms-1 text-success'></i> : '' : ''}</p>
                              <p className='mb-0 d-flex justify-content-between' style={{fontSize: "12px"}}>{nombre.verificado ? nombre.verificado : 'No Verificado'}{nadadores.some(nad => nad.identificacion === nombre.identificacion) && <span className='fw-bold'>INSCRITO</span>}</p>
                            </div>
                          </div>
                          <hr className='m-0'/>
                        </div>
                      })
                    ):( 
                      listNombresRanking.map((nombre, indexNombre)=>{
                        return <div key={indexNombre} style={{cursor: "pointer"}} onClick={() => deportistaSeleccionado(nombre.identificacion)}>
                          <div className='d-flex' style={{ background: nadadores.some(nad => nad.identificacion === nombre.identificacion) ? '#E7FEEB' : 'white' }}>
                            <div style={{width: '32px', height: '42px'}}>
                              <img className='me-1 py-1 w-100 h-100' src={nombre?.urlPhoto && nombre?.urlPhoto !== '' ? nombre.urlPhoto : nombre?.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{filter: 'drop-shadow(0 0 1px black)', objectFit: 'contain'}}/>
                            </div>
                            <div>
                              <p className='mb-0 d-flex align-items-center'><b>{nombre.nombre}</b>{nombre.verificado ? nombre.verificado === 'Verificado' ? <i className='pi pi-verified ms-1 text-success'></i> : '' : ''}</p>
                              <p className='mb-0 d-flex justify-content-between' style={{fontSize: "12px"}}>{nombre.verificado ? nombre.verificado : 'No Verificado'}{nadadores.some(nad => nad.identificacion === nombre.identificacion) && <span className='fw-bold'>INSCRITO</span>}</p>
                            </div>
                          </div>
                          <hr className='m-0'/>
                        </div>
                      })
                    )}
                  </div>
                </OverlayPanel>
                <label htmlFor="nombre">Nombre Completo</label>
              </div>
              <div className="m-1 form-floating" style={{width: window.innerWidth <= 500 ? '100%' : '150px'}}>
                <input className='form-control' disabled={deportistaGeneral || modificar ? true : false} type="number" name="identificacion" id='identificacion' required defaultValue={deportistaGeneral ? deportistaGeneral.identificacion : ''}/>
                <label htmlFor="identificacion">Identificación</label>
              </div>
              <div className="m-1 form-floating" style={{width: window.innerWidth <= 500 ? '100%' : '190px'}}>
                <input className='form-control' disabled={deportistaGeneral ? deportistaGeneral.verificado === 'Verificado' ? true : false : false} type="date" name="fechaNacimiento" id='fechaNacimiento' required defaultValue={deportistaGeneral ? deportistaGeneral.fechaNacimiento : ''} onChange={sacarEdadyGenero}/>
                <label htmlFor="fechaNacimiento">Fecha De Nacimiento</label>
              </div>
              <div className="m-1 form-floating" style={{width: window.innerWidth <= 500 ? '100%' : '120px'}}>
                <select name="genero" id="genero" className='form-select' aria-label="Default select example" required onChange={sacarEdadyGenero}>
                  <option value="">Elige</option>
                  <option value="Femenino">Femenino</option>
                  <option value="Masculino">Masculino</option>
                </select>
                <label htmlFor="genero">Género</label>
              </div>
              <input className='form-control' type="hidden" name="verificacion" id='verificacion' required defaultValue={deportistaGeneral ? deportistaGeneral.verificado : ''}/>
              <input className='form-control' type="hidden" name="urlPhoto" defaultValue={deportistaGeneral ? deportistaGeneral?.urlPhoto : ''}/>
            </div>
            <hr className='m-1'/>
            <Button type='button' icon='pi pi-list' label='Elegir Pruebas' className='btn btn-primary' style={{borderRadius: '10px', width: '200px'}} onClick={() => elegirPruebas()}></Button>
            <hr className='m-1'/>
            <Mensaje
              anchorId={`nombre`}
              place="top"
              content={'Max. 29 caracteres.'}
              className="bg-primary shadow"
              style={{ zIndex: 1}}
            />
            {mostrar ?(
              mostrarJornadas.length !== 0 ? (
                mostrarJornadas.map((prueba, indexPrueba)=>{
                    return <table key={indexPrueba} className="table table-striped table-hover table-bordered">
                    <thead>
                      <tr>
                        <th colSpan={4}>{`Jornada ${prueba.jornada + 1}`}</th>
                      </tr>
                      <tr>
                        <th colSpan={4}>{acomodarTextoCategoria(mostrarCategorias, listadoCategorias)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pruebasExtras(sacarCantidadPruebas(torneoEspecifico.jornadas[prueba.jornada]), prueba, prueba.jornada)}
                    </tbody>
                  </table>
                })
              ):(
                <></>
              )
            ):(
              <></>
            )}
            {(!validarMaximoPruebas() && pruebasId.length !== 0) ? (
              <>
                <hr className='m-1'/>
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                  <b>{usuario.nombreclub}:</b> has excedido el máximo de pruebas que puedes elegir para este deportista.
                </div>
              </>
            ):(
              <Button type='submit' icon='pi pi-user-plus' label={`${deportistaGeneral ? deportistaGeneral.records ? 'Modificar' : 'Inscribir' : 'Inscribir'}`} className='btn btn-success mt-1' style={{borderRadius: '10px', width: '200px'}} onClick={() => sacarPruebas()}></Button>
            )}
          </form>
          </div>
        </Dialog>
        <Dialog visible={dialogDirectivos} style={{ width: '50em' }} breakpoints={{ '641px': '100%' }} header={`Registro Directivos`} modal className="p-fluid" onHide={() => setDialogDirectivos(false)}>
          <div className="field">
            <div>
              <div className="alert alert-warning alert-dismissible fade show mb-1" role="alert">
                <b>{usuario.directivos.length !== 0 ? 
                 `Tienes ${usuario.directivos.length} directivos guardados. Haz clic en el botón para traerlos de forma más rápida y sencilla. `: 
                'Guardaremos los datos de los directivos para que puedas recuperarlos con un solo clic en futuras inscripciones, sin tener que volver a escribirlos.'}</b>
                {usuario.directivos.length !== 0 ? (
                  <Button className='btn btn-info w-auto' icon='pi pi-user' label={`Traer ${usuario.directivos.length} Directivos`} onClick={() => setDirectivos(usuario.directivos)}/>
                ):(
                  <></>
                )}
              </div>
              <div className="form-floating">
                <input type="text" disabled id='abrev' className='form-control mb-2' defaultValue={usuario ? usuario.abreviatura : ''}/>
                <label htmlFor="abrev">Abreviatura</label>
              </div>
            </div>
            {directivos.map((dire, indexDire) =>{
              return <div key={dire.nombre !== '' ? `${dire.nombre}-${dire.rol}` : indexDire} className='d-flex flex-wrap justify-content-between'>
              <div className="form-floating">
                <input className='form-control mb-2' type="text" maxLength={29} id={`nombreDirectivo${indexDire}`} defaultValue={dire.nombre} />
                <label htmlFor={`nombreDirectivo${indexDire}`}>Nombre Completo</label>
              </div>
              <div className="form-floating">
                <input className='form-control mb-2' type="number" id={`cel${indexDire}`} style={{width: '140px'}} defaultValue={dire.cel}/>
                <label htmlFor={`cel${indexDire}`}>No. Celular</label>
              </div>
              <div className="form-floating mb-2">
                <select id={`rol${indexDire}`} className='form-select' defaultValue={dire.rol}>
                  <option value="">Elige</option>
                  <option value="Entrenador/a Principal">Entrenador/a Principal</option>
                  <option value="Entrenador/a">Entrenador/a</option>
                  <option value="Delegado/a">Delegado/a</option>
                  <option value="Monitor/a">Monitor/a</option>
                  <option value="Medico">Medico</option>
                  <option value="Fisioterapeuta">Fisioterapeuta</option>
                  <option value="Logistica">Logistica</option>
                </select>
                <label htmlFor={`rol${indexDire}`}>Rol</label>
              </div>
              <div className='d-flex align-items-center'>
                {indexDire === directivos.length - 1 && parseInt(idTorneoParticipando !== '' ? torneoEspecifico.jornadas[0].cantDirectivos : 0) > directivos.length ? (
                  <Button icon="pi pi-plus" className='me-1' severity="success" raised style={{borderRadius: '50%'}} onClick={() => anadirCamposDirectivo(indexDire)}/>
                ):(
                  <></>
                )}
                <Button icon="pi pi-minus" severity="danger" raised style={{borderRadius: '50%'}} onClick={() => quitarCamposDirectivo(indexDire)}/>
              </div>
            </div>
            })}
            <Button icon="pi pi-check-circle" label='Registrar Directivos' className='btn btn-success' onClick={() => registrarDirectivos()}/>
          </div>
        </Dialog>
        <Dialog visible={dialogFotosDeportistas} style={{ width: 'auto' }} breakpoints={{ '641px': '100%' }} header={`Fotos Deportistas`} modal className="p-fluid" onHide={() => setDialogFotosDeportistas(false)}>
          <div className="field">
            <div className="alert alert-danger alert-dismissible fade show m-auto" role="alert" style={{maxWidth: '360px', lineHeight: 1.2}}>
              <b>IMPORTANTE:</b> Las fotos que subas a nuestras plataformas no serán compartidas con terceros por nuestro equipo.
              Sin embargo, podrán verse y descargarse en los espacios de resultados. <b>Al subir una imagen, asumes la responsabilidad de contar con la autorización del deportista o su representante legal.</b>
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
            <div className="mt-1 form-floating">
              <select id="tiDeportista" className='form-select' onClick={(e) => misDeportistasRef.current.toggle(e)}></select>
              <OverlayPanel ref={misDeportistasRef}>
                <div style={{height: '300px', overflow: 'auto'}}>
                  <h4 className='text-center'>{listNombresRanking.length} Deportistas</h4>
                  <hr className='m-0'/>
                  {busquedaListNombresRanking.length !== 0 ?(
                    busquedaListNombresRanking.map((nombre, indexNombre)=>{
                      return <div key={indexNombre} style={{cursor: "pointer"}} onClick={() => deportistaElegido(nombre)}>
                        <div className='d-flex'>
                          <div style={{width: '32px', height: '42px'}}>
                            <img className='me-1 py-1 w-100 h-100' src={nombre?.urlPhoto && nombre?.urlPhoto !== '' ? nombre.urlPhoto : nombre?.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{filter: 'drop-shadow(0 0 1px black)', objectFit: 'contain'}}/>
                          </div>
                          <div>
                            <p className='mb-0 d-flex align-items-center'><b>{nombre.nombre}</b>{nombre.verificado ? nombre.verificado === 'Verificado' ? <i className='pi pi-verified ms-1 text-success'></i> : '' : ''}</p>
                            <p className='mb-0' style={{fontSize: "12px"}}>{nombre.verificado ? nombre.verificado : 'No Verificado'}</p>
                          </div>
                        </div>
                        <hr className='m-0'/>
                      </div>
                    })
                  ):( 
                    listNombresRanking.map((nombre, indexNombre)=>{
                      return <div key={indexNombre} style={{cursor: "pointer"}} onClick={() => deportistaElegido(nombre)}>
                        <div className='d-flex'>
                          <div style={{width: '32px', height: '42px'}}>
                            <img className='me-1 py-1 w-100 h-100' src={nombre?.urlPhoto && nombre?.urlPhoto !== '' ? nombre.urlPhoto : nombre?.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{filter: 'drop-shadow(0 0 1px black)', objectFit: 'contain'}}/>
                          </div>
                          <div>
                            <p className='mb-0 d-flex align-items-center'><b>{nombre.nombre}</b>{nombre.verificado ? nombre.verificado === 'Verificado' ? <i className='pi pi-verified ms-1 text-success'></i> : '' : ''}</p>
                            <p className='mb-0' style={{fontSize: "12px"}}>{nombre.verificado ? nombre.verificado : 'No Verificado'}</p>
                          </div>
                        </div>
                        <hr className='m-0'/>
                      </div>
                    })
                  )}
                </div>
              </OverlayPanel>
              <label htmlFor="tiDeportista">Elige el deportista</label>
            </div>
            <hr className='m-2'/>
            {deportistaSelectRanking && (
              <>
                <h6 className='text-center mb-0'>{deportistaSelectRanking.nombre}</h6> 
                <div className={`w-100 border mx-1 shadow-sm position-relative overflow-hidden ${!preview && 'd-flex justify-content-center align-items-center'}`} style={{maxWidth: '360px', height: '180px'}}>
                  {(!preview && (!deportistaSelectRanking.urlPhoto || deportistaSelectRanking.urlPhoto === '') && !cargandoRecorte) && <label htmlFor={`subirFoto`} className='w-100 d-flex justify-content-center align-items-center' style={{cursor: 'pointer'}}><span>¡Clic Aqui!</span></label>}
                  {(preview && !cargandoRecorte) && (
                    <Cropper
                      image={preview}
                      crop={crop}
                      zoom={zoom}
                      aspect={5 / 5}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  )} 
                  {(!preview && (deportistaSelectRanking.urlPhoto && deportistaSelectRanking?.urlPhoto !== '') && !cargandoRecorte) && <label htmlFor={`subirFoto`} style={{cursor: 'pointer'}}><img src={deportistaSelectRanking ? deportistaSelectRanking.urlPhoto ? deportistaSelectRanking.urlPhoto : preview : preview} alt="Foto" className='w-100 h-100' style={{objectFit: 'contain', filter: 'drop-shadow(0 0 5px black)'}}/></label>}
                  {cargandoRecorte && <div className='h-100 d-flex justify-content-center align-items-center'><i className='pi pi-spin pi-spinner-dotted' style={{fontSize: '3rem'}}></i></div>}
                  <input type="file" id={`subirFoto`} accept="image/*" hidden onChange={cargarFoto} />
                </div>
                {preview && ( 
                  <>
                    <div className='d-flex justify-content-around'>
                      {!fotoRecortada && <Button type='button' icon="pi pi-expand" label='Recortar' className='btn btn-info w-auto mt-1' onClick={() => recortarArea()}/>}
                      {(fotoRecortada && !fotoSinFondo) && <Button type='button' icon="pi pi-microchip-ai" label='Quitar Fondo' className='btn btn-secondary w-auto mt-1' onClick={() => quitarFondo()}/>}
                    </div>
                  </>
                )}
              </>
            )}
            <hr className='m-1'/>
            <div className='w-100 d-flex flex-wrap justify-content-between mt-1'>
              {(preview && fotoRecortada) && <Button icon='pi pi-image' label='Guardar' className='w-auto btn btn-success' onClick={() => subirFoto(blobFoto, deportistaSelectRanking.identificacion)}/>}
              {deportistaSelectRanking?.urlPhoto && <Button icon='pi pi-times' label='Eliminar' className='w-auto btn btn-danger' onClick={() => eliminarFoto(deportistaSelectRanking.identificacion)}/>}
            </div>
            <hr className='m-1'/>
            <div className="alert alert-info alert-dismissible fade show m-auto" role="alert" style={{maxWidth: '360px', lineHeight: 1.2}}>
              <b>IMPORTANTE:</b> Una vez hayas subido las fotos de los deportistas, <b>recarga la plataforma</b> antes de inscribirlos al evento.
              Esto es necesario para que las fotos se asocien correctamente.
              Si no recargas, <b>los deportistas quedarán sin foto en la inscripción</b>.
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          </div>
        </Dialog>
        <Dialog visible={pdfUrl ? true : false} maximizable style={{ width: '50em' }} breakpoints={{ '641px': '100%' }} header={`Reporte ${usuario.nombreclub}`} modal className="p-fluid" onHide={() => setPdfUrl()}>
          <div className="field">
            <div className='mb-2 pdf-min pdf-max' style={{width: '100%'}}>
              <embed src={pdfUrl} width='100%' height='100%' type='application/pdf'/>
            </div>
            <div className='d-flex justify-content-between mb-2'>
              <Button icon="pi pi-download" className='p-2' text tooltip='Descargar Reporte' tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}} style={{borderRadius: '10px'}} onClick={() => descargar()}></Button>
            </div>
          </div>
        </Dialog>
        <Dialog visible={dialogMensajes} maximizable style={{ width: '50em' }} breakpoints={{ '641px': '100%' }} header={`Mensajes`} modal className="p-fluid" onHide={() => setDialogMensajes(false)}>
          <div className="field position-relative" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '80px' }}>
              {mensajes.length !== 0 ? (
                mensajes.map((men, indexMen)=>{
                  return <div key={indexMen}>
                    <div className='d-flex align-items-start'>
                      <Avatar className="flex align-items-center justify-content-center mr-2" image={men.photo} label={men.photo !== null ? '' : men.nombreclub[0]} size="large"/>
                      <div className='ms-1 bg-light p-1 shadow-sm border position-relative' style={{borderRadius: '10px', width: '85%'}}>
                        {usuario.nombreclub === men.nombreclub || usuario.nombreclub === 'PROWEBSPORTS' ? (
                          <i title='Eliminar' className='pi pi-times-circle text-danger position-absolute' style={{right: "5px", cursor: 'pointer'}} onClick={() => eliminarMensaje(idTorneoParticipando, men.id)}></i>
                        ):(
                          <></>
                        )}
                        <div className='d-flex flex-wrap align-items-end'>
                          <b className='mb-0'>{men.nombreclub}</b>
                          <p className='mb-0 text-muted ms-1' style={{fontSize: "0.8rem"}}>{arreglarFecha(men.fecha)}</p>
                        </div>
                        <p className='mb-0' style={{lineHeight: 1.3}}>{men.mensaje}</p>
                      </div>
                    </div>
                    <hr className='m-2'/>
                  </div>
                })
              ):(
                <div className='text-center'>
                  <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                  <h1>¡Bienvenido!</h1>
                  <p>No hay mensajes aún.</p>
                </div>
              )}
            </div>
            <div className='w-100 d-flex align-items-end position-sticky bottom-0'>
              <textarea className='form-control mt-1' rows="2" id="mensaje" placeholder='Mensaje...'></textarea>
              <Button icon='pi pi-send' className="btn btn-success" onClick={() => enviarMensaje()}/>
            </div>
          </div>
        </Dialog>
        <Dialog visible={dialogRelevos} maximizable style={{ width: '50em' }} breakpoints={{ '641px': '100%' }} header={`Inscripción Relevos`} modal className="p-fluid" onHide={() => setDialogRelevos(false)}>
          <div className="field">
            <motion.div
              className="card m-1 pt-1 col"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1}}
            >
              <form onSubmit={onSubmitRelevo} className='d-flex align-items-center flex-wrap'>
                <div className="card-body w-100">
                  <div className='d-flex flex-wrap justify-content-between mb-1'>
                    <div className="form-floating w-100" style={{ maxWidth: '250px'}}>
                      <select name="jornada" id='jornada' className='form-select' required onChange={(ev) => setElegirRelevos(parseInt(ev.target.value))}>
                        <option value={-1}>Elige la jornada</option>
                        {relevos.length !== 0 ?(
                          relevos.map((_, indexJornada)=>{
                            return <option key={indexJornada} value={indexJornada}>{`Jornada ${indexJornada + 1}`}</option>
                          })
                          ):(
                          <option value="">No hay jornadas</option>
                        )}
                      </select>
                      <label htmlFor="jornada">{`${relevos.length} Jornadas Disponibles`}</label>
                    </div>
                    <div className="form-floating w-100" style={{ maxWidth: '430px'}}>
                      <select name="relevo" id='relevo' className='form-select' required onChange={(ev) => setRelevoElegido(ev.target.value)}>
                        <option value="">Elige el relevo</option>
                        {elegirRelevos !== -1 ?(
                          relevos[elegirRelevos].map((rel)=>{
                            return <option key={rel.id} value={rel.id}>{`${rel.id} | ${rel.prueba.prueba} - ${rel.categoria}`}</option>
                          })
                          ):(
                          <option value="">No hay relevos</option>
                        )}
                      </select>
                      <label htmlFor="relevo">{`${elegirRelevos !== -1 ? relevos[elegirRelevos].length : 0} Relevos Disponibles`}</label>
                    </div>
                  </div>
                  {esRelevoMaster ? (
                    <div className={`alert ${inputsDeportistasRelevos.reduce((acumulador, elemento) => acumulador + elemento.edad, 0) >= relevoEdadInicioFin.edadI && inputsDeportistasRelevos.reduce((acumulador, elemento) => acumulador + elemento.edad, 0) <= relevoEdadInicioFin.edadF ? 'alert-success' : 'alert-danger'} alert-dismissible fade show m-0 mb-1 p-1`} role="alert">
                      <b>Suma Edades: {inputsDeportistasRelevos.reduce((acumulador, elemento) => acumulador + elemento.edad, 0)}</b>
                    </div>
                  ):(
                    <></>
                  )}
                  {inputsDeportistasRelevos.length !== 0 ?(
                    inputsDeportistasRelevos.map((inp, indexInp)=>{
                      return <div key={indexInp} className="p-inputgroup flex-1 mb-1">
                      <Dropdown value={inp} onChange={(e) => agregarDatosAlInputs(e.value, indexInp)} filter options={listaDeportistasRelevo} placeholder={listaDeportistasRelevo.length + ' Deportistas Disponibles'} optionLabel='name'/>
                    </div>
                    })
                  ):(
                    <></>
                  )}
                  <div className='d-flex justify-content-center align-items-center'>
                    <Button
                      type="submit"
                      icon='pi pi-check'
                      label="Inscribir Relevo"
                      className="btn btn-success"
                      style={{ width: '200px'}}
                      disabled={esRelevoMaster ? !(inputsDeportistasRelevos.reduce((acumulador, elemento) => acumulador + elemento.edad, 0) >= relevoEdadInicioFin.edadI && inputsDeportistasRelevos.reduce((acumulador, elemento) => acumulador + elemento.edad, 0) <= relevoEdadInicioFin.edadF) : false}
                    />
                    <div className="d-flex align-items-center m-1">
                      <Checkbox inputId="relevo" name="relevo" onChange={e => setVisibilidadRelevos(e.checked)} checked={visibilidadRelevos}></Checkbox>
                      <label htmlFor="relevo" className="ml-2">Ocultar Relevo</label>
                    </div>
                  </div>
                  <hr className='m-1'/>
                  <div className='table-responsive'>
                    <table className='table table-bordered table-striped table-hover'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Deportistas</th>
                          <th>Identificación</th>
                          <th>Relevo</th>
                          <th>Genero</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {nadadoresRelevo.length !== 0 ?(
                          nadadoresRelevo.map((rel, indexRel)=>{
                            return <tr key={indexRel}>
                              <td>{indexRel + 1}</td>
                              <td className='dropdown'>
                                <span className='btn btn-secondary btn-sm dropdown-toggle' id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                {rel.equipo[0]}</span>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                  {rel.equipo.map((eq, indexEq)=>{
                                    return <li key={indexEq} className="dropdown-item">{eq}</li>
                                  })}
                                </ul>
                              </td>
                              <td className='dropdown'>
                                <span className='btn btn-secondary btn-sm dropdown-toggle' id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                {rel.identificacion.split(',')[0]}</span>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                  {rel.identificacion.split(',').map((eq, indexEq)=>{
                                    return <li key={indexEq} className="dropdown-item">{eq}</li>
                                  })}
                                </ul>
                              </td>
                              <td>{rel.categoria}</td>
                              <td>{rel.genero}</td>
                              <td><img
                                title='Eliminar'
                                style={{ width: "25px", cursor: "pointer" }}
                                src={require("../img/icono-eliminarFoto.webp")}
                                alt="icono eliminar"
                                onClick={() => eliminarNadadorRelevo(indexRel)}
                              /></td>
                            </tr>
                          })
                        ):(
                          <tr>
                            <td colSpan={6}>No hay relevos inscritos aún.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </motion.div>
          </div>
        </Dialog>
      </motion.div>
      <div className='contactenos'>
        <Conctatenos/>
      </div>
    </>
  );
}

export default InscripcionNadadores;